import { render } from "./EditMeeting.vue?vue&type=template&id=064560f1&scoped=true"
import script from "./EditMeeting.vue?vue&type=script&lang=js"
export * from "./EditMeeting.vue?vue&type=script&lang=js"

import "./EditMeeting.vue?vue&type=style&index=0&id=064560f1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064560f1"]])

export default __exports__